import moment from 'moment'

export const formatRegister = (date) => moment(date).format('DD/MM/YYYY')
